import { Injectable } from "@angular/core";

@Injectable()
export class WysiwygService {
  toMarkdown(value: string): string {
    return value;
  }

  fromMarkdown(value: string): string {
    return value;
  }

  getCampaignVariablesDataSource(): string[] {
    return [
      "firstName",
      "lastName",
      "businessName",
      "ssn",
      "vatNumber",
      "email",
      "phone"
    ];
  }

  getCampaignVariablesEscapeChar(): string[] {
    return ["{{", "}}"];
  }
}
